<template>
    <div v-if="preloader === true">
        <template> 
            <v-dialog v-model="preloader" hide-overlay persistent width="300">
                <v-progress-linear indeterminate></v-progress-linear>
            </v-dialog>
        </template>
    </div>

    <div v-else>
        <template v-if="isMobile">
          <div class="mobile-test-report-sticky-header">
            <div class="mobile-test-report-header d-flex align-center px-4">
              <v-btn icon large class="mr-1" @click="$router.back()">
                <v-icon size="28">mdi-arrow-left</v-icon>
              </v-btn>
              <div class="text-h6 font-weight-bold">Test Report</div>
            </div>
            <v-tabs
              :value="stagesIndex"
              class="mobile-test-report-tabs"
              show-arrows
              hide-slider
              @change="switchResult($event)"
            >
              <v-tab
                v-for="(btn, index) in mobileStageButtons"
                :key="btn.status || index"
                :disabled="btn.disable"
              >
                {{ btn.status }}
              </v-tab>
            </v-tabs>

            <v-card class="mobile-candidate-card mx-4 mt-3 rounded-xl" outlined elevation="0">
              <div
                class="d-flex align-center justify-space-between pa-4 cursor"
                @click="mobileCandidateCardExpanded = !mobileCandidateCardExpanded"
              >
                <div>
                  <p class="font-weight-bold text-h6 mb-0">{{ personalInfo?.firstName | capitalizeFirst }} {{ personalInfo?.lastName | capitalizeFirst }}</p>
                  <p class="subtitle-2 mb-0">{{ personalInfo?.contactInfo?.email }}</p>
                </div>
                <v-icon>{{ mobileCandidateCardExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
              <v-expand-transition>
                <div v-if="mobileCandidateCardExpanded" class="px-4 pb-4 mobile-candidate-card-details">
                  <v-divider class="mb-3"></v-divider>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>School</span><span>{{ interviewDetails?.interviewSlotDetails[0]?.schoolName ?? 'NA' }}</span>
                  </div>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>Current CTC</span><span>{{ interviewDetails?.candidateDetails?.currentCTC ?? 'NA' }} LPA</span>
                  </div>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>Expected CTC</span><span>{{ interviewDetails?.candidateDetails?.expectedCTC ?? 'NA' }} LPA</span>
                  </div>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>Total Exp</span><span>{{ interviewDetails?.candidateDetails?.totalExperience?.years || '0 Year' }} {{ interviewDetails?.candidateDetails?.totalExperience?.months || '0 Month' }}</span>
                  </div>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>Relevant Exp</span><span>{{ interviewDetails?.candidateDetails?.relevantExperience?.years || '0 Year' }} {{ interviewDetails?.candidateDetails?.relevantExperience?.months || '0 Month' }}</span>
                  </div>
                  <div class="d-flex justify-space-between mobile-detail-row">
                    <span>Notice Period</span><span>{{ interviewDetails?.candidateDetails?.noticePeriod ?? 'NA' }} days</span>
                  </div>
                </div>
              </v-expand-transition>
            </v-card>
          </div>

          <div class="mobile-report-body">
            <v-card class="mobile-overall-score-card mx-4 mt-3 pa-4 rounded-xl" color="#CBF0E0" outlined elevation="0">
              <div class="d-flex align-center justify-space-between">
                <span class="text-subtitle-1 font-weight-bold">Overall score</span>
                <span class="text-h6 font-weight-bold">{{ overAllScore.toFixed(2) }} / 10</span>
              </div>
            </v-card>

            <div v-if="tabs.data && tabs.data[0] && tabs.data[0][0]" class="mobile-competency-cards mx-4 mt-3">
              <v-card
                v-for="(item, index) in tabs.data[0][0].data"
                :key="index"
                class="pa-4 rounded-xl mb-3"
                outlined
                elevation="0"
              >
                <div class="d-flex justify-space-between align-start">
                  <div class="mobile-competency-text">
                    <div class="font-weight-bold text-subtitle-2">{{ (item.title || item.name || '').replace('*', '').trim() }}</div>
                    <div class="text-body-2 grey--text text--darken-1 mt-1">{{ item.description }}</div>
                  </div>
                  <v-chip small :color="getScoreChipColor(item.rating)" class="ml-2 flex-shrink-0">Score - {{ item.rating }}</v-chip>
                </div>
              </v-card>
            </div>
          </div>
        </template>
        <template v-else>
        <v-card height="64px" width="100%"
            class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
            style="
          position: fixed;
          z-index: 200;
          top: 0;
          width: 98%;
          padding: 40px 0;
        ">
            <v-card-title class="pl-0 ml-0">
                <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/campaign')">
                    Campaigns
                </p>
                <v-icon class="breadcrumb-arrow-unselected"
                    style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="backToCampaignUserListingPage">
                    {{ campaignName }}
                </p>
                <v-icon class="breadcrumb-arrow-unselected"
                    style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                <p class="breadcrumb-text" style="margin-top: 2px">Test Report</p>
                <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
            </v-card-title>
            <UserNavMenu/>
        </v-card>
        <v-card height="84px" width="100%"
            class="background ml-4 mr-2 my-0 px-4 transparent elevation-0 d-flex flex-column justify-space-between align-center"
            style="
            position: fixed;
            z-index: 5;
            top: 1;
            width: 98%;
            right:0px;
            padding-top: 16px;
        ">
            
            <div class="w-100 ml-16 mr-2 my-2">
                <div class="d-flex pb-2 ml-16 justify-space-between align-center" :class="showToggleBtn ? '':''">
                    <h3>{{ personalInfo?.firstName | capitalizeFirst }} {{ personalInfo?.lastName | capitalizeFirst }} - Interview Report </h3>
                    <TestToggleComponent @testChange="switchResult($event)" :buttons="stages" :isSelect="stagesIndex"> </TestToggleComponent>
                </div>
            </div>
        
          
        </v-card>
        <section class="repUpDiv flex-column gap-12">
   
            <template class="mx-4 my-2">
                <v-card class="mx-auto w-100 pa-4 mt-10" outlined>
                    <v-container class="bg-surface-variant pa-0 m-width-none">
                        <v-row class="align-center">
                            <v-col>
                                <v-sheet class="border-right ">
                                    <div class="d-flex align-center justify-start">
                                        <v-avatar size="69">
                                            <v-img :src="proctoringPic || defaultProfilePic"></v-img>
                                        </v-avatar>
                                        <ul style="list-style: none;">
                                            <li class="text-body-2 font-weight-bold">{{ personalInfo?.firstName }} {{
        personalInfo?.lastName }}</li>
                                            <li class="text-body-2 font-weight-regular">{{
        personalInfo?.contactInfo?.email }}</li>
                                            <li class="text-body-2 font-weight-regular">{{
        personalInfo?.contactInfo?.phoneNumber }}</li>
                                        </ul>
                                    </div>
                                </v-sheet>
                            </v-col>
                            <v-col>
                                <v-sheet class="border-right">
                                    <div class="d-flex flex-column w-90">                                        
                                        <div>
                                            <span class="text-body-2 font-weight-regular">School - </span>
                                            &nbsp;&nbsp;
                                            <span class="text-body-2 font-weight-bold float-right">{{
        interviewDetails?.interviewSlotDetails[0]?.schoolName }}</span>
                                        </div>
                                        <div>
                                            <span class="text-body-2 font-weight-regular">Current CTC - </span>
                                            <span class="text-body-2 font-weight-bold float-right">{{
        interviewDetails?.candidateDetails?.currentCTC ?? 'NA' }} LPA</span>
                                        </div>
                                        <div>
                                            <span class="text-body-2 font-weight-regular">Expected CTC - </span>
                                            <span class="text-body-2 font-weight-bold float-right">{{
        interviewDetails?.candidateDetails?.expectedCTC }} LPA</span>
                                        </div>
                                    </div>
                                </v-sheet>
                            </v-col>
                            <v-col>
                                <v-sheet class="border-right">
                                    <div class="d-flex flex-column w-90">
                                        <div>
                                            <span class="text-body-2 font-weight-regular">Total exp - </span>
                                            &nbsp;&nbsp;
                                            <span class="text-body-2 font-weight-bold float-right">{{
        interviewDetails?.candidateDetails?.totalExperience?.years || '0 Year'  }}  {{
        interviewDetails?.candidateDetails?.totalExperience?.months || '0 Month' }}
                                                </span>
                                        </div>
                                        <div>
                                            <span class="text-body-2 font-weight-regular">Relevant Exp - </span>
                                            &nbsp;&nbsp;
                                            <span class="text-body-2 font-weight-bold float-right">{{
        interviewDetails?.candidateDetails?.relevantExperience?.years || '0 Year' }}
                                                {{ interviewDetails?.candidateDetails?.relevantExperience?.months  || '0 Month'}}
                                                </span>
                                        </div>
                                        <div>
                                            <span class="text-body-2 font-weight-regular">Notice Period - </span>
                                            &nbsp;&nbsp;
                                            <span class="text-body-2 font-weight-regular float-right">{{
        interviewDetails?.candidateDetails?.noticePeriod }} days</span>
                                        </div>
                                    </div>
                                </v-sheet>
                            </v-col>
                            <v-col cols="2">
                                <v-sheet class="border-right">
                                    <section
                                        class="score-container d-flex justify-center align-center flex-column py-3 px-4">
                                        <p>
                                            <span class="font-weight-bold"> {{ overAllScore.toFixed(1) }}</span> / <span
                                            class="font-weight-bold" >10</span>

                                        </p>
                                        <span class="text-caption">Overall score</span>
                                    </section>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <div class="d-flex justify-space-between w-100 align-center mt-4">
                    <p class="text-subtitle-1"><span>Scheduled On:</span> <span>{{getInterviewScheduledDate ?? 'invalid date'}}</span></p>
                    <div class="d-flex align-center gap-2">
                        <div class="toggle-btn--container" v-if="showToggleBtn">           
                        <v-btn-toggle
                            v-model="roundToggleIndex"
                            mandatory
                            dense
                            rounded
                            @change="updateRoundFeedback"
                        >
                            <v-btn
                            v-for="(round, index) in rounds"
                            :class="roundToggleIndex == index ? 'gray-05 blue--text caption white' : 'caption white'"
                            :key="round"
                            >
                            Round {{ round }}
                            </v-btn>
                        </v-btn-toggle>
                        </div>
                        <v-btn v-if="downloadAttendanceReport" icon :loading="downloadingAttendance" @click="downloadAttendanceCSV" title="Download Attendance Report" >
                        <v-img src="../assets/svg/import-icon.svg" />
                        </v-btn>
                    </div>
                </div>
            </template>

        </section>
        <InterviewScoreCard :readOnly="true" :interViewFeedbackData="currentRoundFeedback" v-if="reportDataLoaded" :tabsData="tabs" :showTabs="showTabs" :ratingScale="ratingScale"></InterviewScoreCard>
        </template>
        <!-- <section class="bottomDiv flex-column">
        <span class="text-body-2 font-weight-bold">Candidate Assessment</span>
        <div class="interview-panels">
            <v-row>
                <v-col cols="6"></v-col>
                <v-col class="d-flex justify-center text-center m-left-10"  cols="2"><span class="interviewer-name" v-if="colVisiblity[2]">    <v-tooltip top >
                                            <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                {{interViewFeedback[2].interviewerEmail ? interViewFeedback[2].interviewerEmail : '---' }}
                                            
                                            </span>
                                            </template>
                                            <div > {{interViewFeedback[2].interviewerEmail ? interViewFeedback[2].interviewerEmail : '---' }}</div>
                                        </v-tooltip></span></v-col>
                <v-col class="d-flex justify-center text-center m-left-10"  cols="2"><span class="interviewer-name" v-if="colVisiblity[1]">
                    <v-tooltip top >
                                            <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                {{interViewFeedback[1].interviewerEmail ? interViewFeedback[1].interviewerEmail : '---' }}
                                            
                                            </span>
                                            </template>
                                            <div > {{interViewFeedback[1].interviewerEmail ? interViewFeedback[1].interviewerEmail : '---' }}</div>
                                        </v-tooltip></span></v-col>
                <v-col class="d-flex justify-center text-center m-left-10"  cols="2"><span class="interviewer-name" v-if="colVisiblity[0]"> <v-tooltip top >
                                            <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                {{interViewFeedback[0].interviewerEmail ? interViewFeedback[0].interviewerEmail : '---' }}
                                            
                                            </span>
                                            </template>
                                            <div > {{interViewFeedback[0].interviewerEmail ? interViewFeedback[0].interviewerEmail : '---' }}</div>
                                        </v-tooltip></span></v-col>
            </v-row>
        </div>
        <div class="larger-bottom">
            <div class="central-table">
                <div class="main-table rounded-xl">           
                        <div class="vertical-menu">
                            <div class="d-flex flex-column">
                                <div>
                                <div
                                    v-for="(data, index) in skills"
                                    :key="index"
                                    @click="selectSkill(data.skillName, index)"
                                    :class="['commonColoredContainer',    selectedSkill != data.skillName
                                    ? findColor(data.skillName)
                                    : findColorForSelected(data.skillName)
                                    ]"
                                 
                                    >
                                    <span class="spanContainer caption">{{
                                    data.skillName
                                    }}</span>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="data-grid">
                             <v-row v-if="selectedSkill == 'Core Skills'" class="button-toggle-row">
                                <v-col cols="6">
                                        <v-btn-toggle class="px-6"
                                        v-if="coreSkillToggle.length > 1"
                                        v-model="toggleType"
                                        mandatory
                                        dense
                                        rounded
                                    >
                                        <v-btn
                                        v-for="(skillBtn, index) in coreSkillToggle"
                                        class="w-100 skill-btn"
                                        :class="
                                        toggleType == index
                                            ? 'btn-color white--text caption'
                                            : '#000000 btn-color--text caption'
                                        " :key="skillBtn"
                                        >
                                        {{ skillBtn }}
                                        </v-btn>
                                    </v-btn-toggle>
                                    <h3 class="core-subject-title" v-else>{{coreSkillToggle[0]}}</h3   >
                                </v-col>
                    <v-col cols="2"  :class="[ colColors[2]]" ></v-col>
                    <v-col cols="2" :class="[ colColors[1]]" ></v-col>
                    <v-col cols="2"  :class="[ colColors[0]]" ></v-col>
                 
                   
                </v-row>
                            <v-row v-for="(data, index) in displayData" class="mx-h-81" :key="data.title" :class="{ 'first-row': index === 0 && selectedSkill !== 'Core Skills' }" >
                            <v-col cols="6">
                                <p  class="feedback-title">{{data.title}}</p>
                                <p class="feedback-desc">{{data.description}}</p>
                            </v-col>
                            <v-col cols="2" class="feedback-title d-flex justify-center text-center" :class="[ colColors[2]]"><span v-if="colVisiblity[2]">{{data.rating2 > 9 ? data.rating2: `0${data.rating2}` }} / 10</span></v-col>
                            <v-col cols="2" class="feedback-title d-flex justify-center text-center" :class="[ colColors[1]]"><span v-if="colVisiblity[1]">{{data.rating1  > 9 ? data.rating1: `0${data.rating1}` }} / 10</span></v-col>
                            <v-col cols="2" class="feedback-title d-flex justify-center text-center"  :class="[ colColors[0]]"><span v-if="colVisiblity[0]">{{data.rating  > 9 ? data.rating: `0${data.rating}` }} / 10</span></v-col>
                            </v-row>
                                <v-row class="last-row mb-10px" align-end >
                                    <v-col cols="6" class="pl-8 average-text d-flex justify-start align-end">
                                        {{ subjectAverageRatings.name  }} Average
                                    </v-col>
                                    <v-col  cols="2" class="feedback-title justify-center text-center average-text d-flex align-end"  :class="[ colColors[2]]"><span v-if="colVisiblity[2]">{{subjectAverageRatings.avg.avg2 | tofixRating}}</span></v-col>
                                    <v-col  cols="2" class="feedback-title d-flex justify-center text-center align-end average-text"  :class="[ colColors[1]]"><span v-if="colVisiblity[1]">{{ subjectAverageRatings.avg.avg1 | tofixRating}}</span></v-col>
                                    <v-col  cols="2" class="feedback-title d-flex justify-center text-center  align-end average-text" :class="[ colColors[0]]"><span v-if="colVisiblity[0]">{{ subjectAverageRatings.avg.avg0 | tofixRating}}</span></v-col>
                             </v-row>
                        </div>
                </div>
            </div>
        </div>
             <div class="comment-section">
                                  <v-row >
                <v-col cols="6"  class="pl-12 interviewer-name d-flex justify-start align-center" ><p>Comments</p></v-col>
                <v-col class="text-right interviewer-name rounded-lg m-left-5 cursor" cols="2"  :class="[ colColors[2]]" @click="dialogHandler(interViewFeedback[2])">
                    <div class="comment-recommendations"  v-if="colVisiblity[2]" >
                        <p :class="interViewFeedback[2]?.recommendation == 'HOLD' ? 'hold-txt': 'recommend-txt'" >{{interViewFeedback[2].recommendation}}</p>
                        <p  class="interview-remark">{{interViewFeedback[2].remark | strippedContent}}</p> 
                    </div>
                </v-col>
                      <v-col class="text-right interviewer-name rounded-lg m-left-5 cursor"  cols="2"  :class="[ colColors[1]]" @click="dialogHandler(interViewFeedback[1])">
                    <div class="comment-recommendations"  v-if="colVisiblity[1]" >
                        <p :class="interViewFeedback[1]?.recommendation == 'HOLD' ? 'hold-txt': 'recommend-txt'" >{{interViewFeedback[1].recommendation}}</p>
                        <p  class="interview-remark">{{interViewFeedback[1].remark | strippedContent}}</p> 
                    </div>
                </v-col>
                      <v-col class="text-right interviewer-name rounded-lg m-left-5 cursor" cols="2"  :class="[ colColors[0]]" @click="dialogHandler(interViewFeedback[0])">
                    <div class="comment-recommendations"  v-if="colVisiblity[0]" >
                        <p :class="interViewFeedback[0]?.recommendation == 'HOLD' ? 'hold-txt': 'recommend-txt'" >{{interViewFeedback[0].recommendation}}</p>
                        <p  class="interview-remark">{{interViewFeedback[0].remark | strippedContent}}</p> 
                    </div>
                </v-col>
            </v-row>   
                </div>
</section>
    <div v-if="dialogActive">

        <v-dialog v-model="dialogActive"  max-width="366px">
        <v-card fluid  min-height="250px">
          <v-container fluid class="pa-0">
            <v-card-text class="text-center">
                <v-icon size="24" class="icon-aligner" @click="dialogHandler">mdi-close</v-icon>
                <div class="d-flex flex-column justify-space-between">
                    <p class="text-h5 pt-4 pb-4 font-weight-bold">{{dialogContent.recommendation}}</p>
                <p class="text-disabled grey--text text-subtitle-1 remark-color">
                {{dialogContent.remark | strippedContent}}
              </p>
                </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </div> -->
    </div>
</template>

<script>
import AuthService from "../services/AuthService";
import CampaignController from '@/controllers/CampaignController';
import {  doc, getDoc  } from "firebase/firestore";
import { db } from "../firebase.js";
import InterviewScoreCard from "@/components/InterviewScoreCard.vue";
import TestToggleComponent from "@/components/ReportComponents/TestToggleComponent.vue";
import { mapGetters } from "vuex";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
    components:{
        InterviewScoreCard,
        TestToggleComponent,
        UserNavMenu
    },
    data() {
        return {
            stages:[
                {status:'SCREENING', disable:true, },
                {status:'MAINS', disable: true,},
                {status: 'DEMO', disable: true},
                {status: 'INTERVIEW', disable:true}
            ], 
            stagesIndex: 3,
            toggleType: 0,
            preloader: true,
            campName: "",
            personalInfo: null,
            interviewDetails: null,
            interViewFeedback: null,
            proctoringPic: null,
            defaultProfilePic: require('@/assets/Profile 1.svg'),
            selectedSkill: 'Core Skills',
            skills: null,
            selectedSkillIndex: 0,
            coreSkillToggle: [],
            allSubjectScore: [],
            resultMap: {},
            avgMap: {},
            colColors: ['', '',''], 
            colVisiblity: [false, false, false],
            dialogActive: false,
            dialogContent: {},
            campaignName: "",
            campaignType: "",
            reportDataLoaded: false,  
            tabs:{
                headers: [],
                data:[]
            },
            showToggleBtn: false,
            latestFeedbackRound:1,
            roundToggleIndex:0,
            overAllScore:0,
            showTabs: true,
            ratingScale: 10,
            downloadAttendanceReport: true,
            numberOfRounds: [],
            currentTestRoundIndex: 0,
            mobileCandidateCardExpanded: true
        }
    },
    filters: {
    strippedContent: function(string) {
           return string.replace(/<\/?[^>]+>/ig, " "); 
        },
    tofixRating: function(number){
       return number % 1 !== 0 || !Number.isInteger(number) ? number.toFixed(1) : number
    }
},
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        mobileStageButtons() {
            const list = this.stages.map((stage) => ({ ...stage }));
            if (this.numberOfRounds.length > 0) {
                this.numberOfRounds.forEach((item, index) => {
                    if (index < this.currentTestRoundIndex) {
                        const stage = list.find((s) => s.status === item.toUpperCase());
                        if (stage) stage.disable = false;
                    }
                });
            }
            const interviewStage = list.find((s) => s.status === 'INTERVIEW');
            if (interviewStage) interviewStage.disable = false;
            return list;
        },
        displayData() {
            if (this.selectedSkill == 'Core Skills') {
                return this.resultMap['coreSkill'+this.coreSkillToggle[this.toggleType]]
            } else {
                return this.resultMap['skill'+this.selectedSkill]
             }
        },
     subjectAverageRatings() {
         if (this.selectedSkill === 'Core Skills') {
             return {name: this.coreSkillToggle[this.toggleType], avg: this.avgMap['coreSkill'+this.coreSkillToggle[this.toggleType]] };
         } else {   
            return {name:this.selectedSkill, avg: this.avgMap['skill'+this.selectedSkill]};
    }
  },
  getInterviewScheduledDate() {
    const [year, month, day] = this.interviewDetails?.interviewSlotDetails[this.roundToggleIndex].slotDate.split("-");
    return `${day}/${month}/${year}`;
  }
     
    },
    async mounted() {
        this.campaignId = this.$route.params.campaignId;
        this.userId = this.$route.params.userId;
        await this.getReport();
        if (!this.isFeedbackV2(this.interViewFeedback)) {
            this.getTabHeaders()
        }
        this.getCampaignDetails()
    },
    methods: {
        async downloadAttendanceCSV() {
            try {
                this.downloadingAttendance = true;

                const body = {
                campaignId: this.campaignId,
                userId:     this.userId,  // whatever your data property is
                round:      this.latestFeedbackRound
                };

                const response = await CampaignController.downloadInterviewAttendanceReport(body);

                if (response.status !== 200) {
                throw new Error("Failed to download CSV");
                }

                const url      = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
                const link     = document.createElement("a");
                link.href      = url;
                link.setAttribute("download", `Interview_Attendance_Round${this.latestFeedbackRound}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error("Attendance download failed:", error);
            } finally {
                this.downloadingAttendance = false;
            }
        },
        calculateOverAllScore() {
            this.overAllScore = 0;
            if (this.currentRoundFeedback !== null) {
            
                let avgScore = this.currentRoundFeedback.reduce((total, { avgScore }, _, arr) => total += avgScore / arr.length, 0);
                this.overAllScore = Number(avgScore.toFixed(2)) || 0;
            }
           
        },
        switchResult(event){
            this.stagesIndex = event
            let page = this.stagesIndex <= 1 ? 'testreport' : this.stagesIndex == 2 ? 'demoreport': ''
            if(this.stagesIndex !== 3){
                this.$router.push({ path: `/${page}/${this.campaignId}/${this.userId}`, query: { isSelect: this.stagesIndex, ...(this.$route.query.redirectedFrom && {redirectedFrom: this.$route.query.redirectedFrom}) } })
            }
        },
        getScoreChipColor(rating) {
            const ratio = Number(rating) / (this.ratingScale || 5);
            if (ratio >= 0.7) return '#CBF0E0';
            if (ratio >= 0.5) return '#FFF4EB';
            return '#F9DBE1';
        },
        getAllRounds(){
        let data = this.interViewFeedback.filter(({round})=> round !== undefined ).map(({round})=>round)
        let unq = new Set(data);
        this.rounds = [...unq].filter(item => item !== undefined)
        this.latestFeedbackRound = Math.max(...this.rounds)
        if(this.$route.query?.round){
            this.roundToggleIndex = Number(this.$route.query?.round)
        }else {
            this.roundToggleIndex = this.latestFeedbackRound -1
        }
       
        if(this.latestFeedbackRound > 1){
            this.showToggleBtn = true
        }
        this.updateRoundFeedback()
        },
        updateRoundFeedback(){
            this.reportDataLoaded = false
            this.latestFeedbackRound = this.roundToggleIndex+1
            this.downloadAttendanceReport = this.interviewDetails?.interviewSlotDetails[this.roundToggleIndex]?.interviewMode == "Online"
            let nameAndEmails = this.interviewDetails.interviewSlotDetails[this.roundToggleIndex].interviewerNameAndEmail
            this.currentRoundFeedback = this.interViewFeedback
                .filter(({ round }) => round == this.latestFeedbackRound)
                .map((item) => ({
                    ...item,
                    name: nameAndEmails.find(ne => ne.email === item.interviewerEmail)?.name
                }));
            this.calculateOverAllScore()
                if (this.isFeedbackV2(this.currentRoundFeedback)) {
                    this.showTabs = false
                    this.ratingScale = 5
                    this.buildFeedbackTabsV2(this.currentRoundFeedback)
                } else {
                    this.showTabs = true
                    this.ratingScale = 10
                    this.getTabHeaders()
                    this.createtableData(this.currentRoundFeedback)
                }
                this.$nextTick(()=>{
                    this.reportDataLoaded = true
            })
        },

        isFeedbackV2(feedback) {
            return Array.isArray(feedback) && feedback.length > 0 && Object.keys(feedback[0]).includes('newFeedBack')
        },

        buildFeedbackTabsV2(allInterviewersFeedback) {
            this.tabs = { headers: [], data: [] }
            if (!allInterviewersFeedback.length) return
            const mergedItems = allInterviewersFeedback[0].newFeedBack.map(item => ({ ...item }))
            allInterviewersFeedback.forEach((interviewer, index) => {
                if (index > 0) {
                    interviewer.newFeedBack.forEach((item, i) => {
                        if (mergedItems[i]) mergedItems[i]['rating' + index] = item.rating
                    })
                }
            })
            this.tabs = {
                headers: [{ name: 'Assessment', totalfeedBackcount: mergedItems.length, ScoredFeedbackCount: 0 }],
                data: [[{ subName: 'Assessment', data: mergedItems }]]
            }
        },

        getTabHeaders(){
            // Core Skills is always the first tab — its data lives in `subjects`, not `skills`.
            this.tabs.headers = [{name: 'Core Skills', totalfeedBackcount: 0, ScoredFeedbackCount: 0}]
            this.interViewFeedback[0].skills.forEach((item) => {
                if (item.skillName !== 'Core Skills') {
                    this.tabs.headers.push({name: item.skillName, totalfeedBackcount: 0, ScoredFeedbackCount: 0})
                }
            })
        },
        async getCampaignDetails(){
                const campaignRef = doc(db,"campaigns",this.campaignId);
                const campaignSnap = await getDoc(campaignRef);
                const campaignData = campaignSnap.data()
                this.campaignName = campaignData.name;
                this.campaignType = campaignData.audienceType;
                return campaignData
            },
        backToCampaignUserListingPage(){
            if (window.opener) {
                window.close();
            } else {
                this.$router.push({
                    path: "/campaignUser",
                    name: "CampaignUserView",
                    query: {
                        id: this.campaignId,
                        campaignType: this.campaignType,
                    },
                });
            }
        },
        dialogHandler(data = '') {
            this.dialogActive = !this.dialogActive;
            this.dialogContent = data
        },
        getColColors() {
            this.interViewFeedback.forEach((item, index) => {
                    this.colColors[index] = item.recommendation == 'HOLD' ? 'hold-bg' : 'recommend-bg'
            })
        },
        getColsVisiblity() {
            this.interViewFeedback.forEach((item, index) => {
                this.colVisiblity[index] = true
            })
        },
          hasDecimal(number) {
            return number % 1 !== 0 || !Number.isInteger(number);
        },
        createAvg(data) {
        for (let key in data) {
            this.getAvgRating(key, data[key])    
            }
        },
        getAvgRating(key, data) {
        let avg ={
            ratingSum:0,
            ratingCount:0,
            rating1Sum:0,
            rating1Count:0,
            rating2Sum:0,
            rating2Count:0
        }
          data.forEach((item)=>{
            let nullArr = [undefined, null, '', NaN]
            if(nullArr.every((nullval)=> item.rating !== nullval)){
                avg.ratingSum += item.rating;
                avg.ratingCount++
            }
                if(nullArr.every((nullval)=> item.rating1 !== nullval)){
                avg.rating1Sum += item.rating1;
                avg.rating1Count++
            }
                if(nullArr.every((nullval)=> item.rating2 !== nullval)){
                avg.rating2Sum += item.rating2;
                avg.rating2Count++
            }
          })
          this.avgMap[key] = {avg0: avg.ratingSum/avg.ratingCount, avg1:avg.rating1Sum/avg.rating1Count, avg2:avg.rating2Sum/avg.rating2Count }
         
        },
        createtableData(interveiwData) {
         this.tabs.data = []
            let subObj = {}
            let skillObj = {}
            interveiwData.forEach((item, index) => {
              
                 item.subjects.forEach((coreSubject) => {
                
                    if (index == 0) {
                        this.resultMap['coreSkill' + coreSubject.subjectName] = coreSubject.feedback;
                        subObj[coreSubject.subjectName] = coreSubject.feedback
                    } else {
                        this.pluckRating('coreSkill'+coreSubject.subjectName, coreSubject.feedback, index)
                        this.pluckRatingtemp(coreSubject.subjectName, coreSubject.feedback, index, subObj)
                    }
                   
                })  
               

                item.skills.forEach((skill) => {
                    if (index == 0 && skill.skillName !== 'Core Skills') {
                        this.resultMap['skill' + skill.skillName] = skill.feedback;
                        skillObj[skill.skillName] = skill.feedback;
                    } else if(skill.skillName !== 'Core Skills'){
                        this.pluckRating('skill' + skill.skillName, skill.feedback, index)
                        this.pluckRatingtemp(skill.skillName, skill.feedback, index, skillObj )
                    }
                }) 
                
                
    })
    let arr = []
    for(const key in subObj){
        arr.push({subName: key, data: subObj[key]})
    }
    this.tabs.data.push(arr)
    // console.log('skill obj',  skillObj)
    for(const key in skillObj){
        // let res = {}
        //   res[key] = skillObj[key]
        
        this.tabs.data.push({subName: key, data: skillObj[key]})
    }
    
},
    pluckRating(key, feedback, outerIndex) {
    feedback.forEach((item, index) => {
        // this.resultMap[key][index]['rating'+outerIndex] = item.rating
        
    })
    },
    pluckRatingtemp(key, feedback, outerIndex, obj) {
    feedback.forEach((item, index) => {
        // this.resultMap[key][index]['rating'+outerIndex] = item.rating
        obj[key][index]['rating'+outerIndex] = item.rating
    })},
        selectSkill(skillName, index) {
        console.log(skillName)
      this.selectedSkill = skillName;
      this.selectedSkillIndex = index;
    },
     findColor(value) {
      var colors = "";
      switch (value) {
        case "Core Skills":
          return "containerCoreSkillLite cursor";
          break;
        case "Pedagogy":
          return "containerPedagigyLite cursor";
          break;
        case "Communication Skills":
          return "containerEnglishLite cursor";
          break;
        case "Digital Literacy":
          return "containerComputerLite cursor";
          break;
        case "Psychometry":
          return "containerPsychrometricLite cursor";
          break;
        default:
          return "containerPsychrometricLite cursor";
      }
    },
    findColorForSelected(value) {
      switch (value) {
        case "Core Skills":
          return "containerCoreSkillHard cursor";
          break;
        case "Pedagogy":
          return "containerPedagigyHard cursor";
          break;
        case "Communication Skills":
          return "containerEnglishHard cursor";
          break;
        case "Digital Literacy":
          return "containerComputerHard cursor";
          break;
        case "Psychometry":
          return "containerPsychrometricHard cursor";
          break;
        default:
          return "containerPsychrometricHard cursor";
      }
    },
        logout() {
            AuthService.logout();
            this.$router.push("/login");
        },
        async getReport() {
            try {
                const response = await CampaignController.getInterviewReport(this.userId, this.campaignId);
                console.log("response_data :", response.data);
                if (response.data?.result) {
                    this.personalInfo = response.data?.result?.personalInfo
                    this.proctoringPic = response.data?.result?.proctoringPic
                    this.interviewDetails = response.data?.result?.interviewDetails
                    this.interViewFeedback = response.data?.result?.interViewFeedback
                    this.reportDataLoaded = true
                    this.downloadAttendanceReport = this.interviewDetails?.interviewSlotDetails[this.roundToggleIndex]?.interviewMode == "Online"
                    const { numberOfRounds, currentTestRoundIndex } = response.data?.result;
                    this.numberOfRounds = numberOfRounds || [];
                    this.currentTestRoundIndex = currentTestRoundIndex || 0;
                    if(numberOfRounds && numberOfRounds.length > 0 ){
                        numberOfRounds.forEach((item, index)=>{
                            if(index < currentTestRoundIndex){
                                this.stages.find((stage)=> stage.status == item.toUpperCase()).disable = false
                            }
                        })
                    }
                    if(this.interViewFeedback && this.interViewFeedback?.length > 0){
                        console.log('getAllRounds')
                        this.getAllRounds()
                    }else{
                        this.latestFeedbackRound = 0
                    }
                    if (!this.isFeedbackV2(this.interViewFeedback)) {
                        this.createtableData(this.interViewFeedback);
                        this.createAvg(this.resultMap)
                        console.log('result map', this.resultMap)
                        // this.selectedSkill = this.interViewFeedback[0].skills[0]
                        this.skills = this.interViewFeedback[0].skills
                        this.coreSkillToggle = this.interViewFeedback[0].subjects.map(item => item.subjectName)
                    }
                    this.getColsVisiblity()
                     this.getColColors()

                } else {
                    console.log('response data error...', response.data.error)
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.preloader = false;
            }
        }
    }
}
</script>
<style scoped>
.mobile-test-report-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--white);
}
.mobile-test-report-header {
  height: 64px;
}
.mobile-test-report-tabs {
  margin: 0 4px;
}
.mobile-test-report-tabs ::v-deep .v-tab--active,
.mobile-test-report-tabs ::v-deep .v-tab--active.v-tab--disabled {
  color: var(--blue-01) !important;
  box-shadow: inset 0 -2px 0 0 var(--blue-01);
}
.mobile-candidate-card {
  border: 1px solid var(--gray-03);
}
.mobile-detail-row {
  padding: 6px 0;
  font-size: 14px;
}
.mobile-report-body {
  background: var(--white);
  padding-bottom: 16px;
}
.mobile-overall-score-card {
  border: 1px solid var(--gray-03);
}
.mobile-competency-text {
  min-width: 0;
}
.toggle-btn--container {
  display: flex;
  justify-content: end;
  .v-btn {
    padding: 10px 24px !important; 
    color: var(--blue-01);
    font-family: "GraphikMedium", sans-serif !important;
    font-weight: 500;
  }
  .v-btn-toggle {
    border: 1px solid var(--blue-01);
  }
}
.row{
    flex: 0 0 auto;
}

.interviewer-name {
    text-wrap: nowrap;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.vertical-menu{
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    overflow: hidden;
}
.mb-10px{
    margin-bottom:0px
}
.mx-h-81{
    max-height: 81px;
}
.icon-aligner{
    margin-left: 90%; 
    margin-top: 2%;
}
.m-left-5{
   margin-left: 5px;
}
.m-left-10{
    margin-left: 10px;
}
.button-toggle-row{
  margin-top: 0px;  
}
.remark-color{
    max-height: 12vh;
    overflow: auto;
    color: #666666;
}
.first-row{
    margin-top: 0px;
}
.bottomDiv{
  margin: 10px 12px 4px 32px;

}
.data-grid{
    display: flex;
    flex-direction: column;
   width: 97vw;
   background-color: #FFFFFF;

}
.last-row {
  flex-grow: 1;
}
.recommend-txt{
    color:#4D695B;
    text-align: left;
}
.hold-txt{
    color:#B7842C;
    text-align: left;
}
.hold-bg{
    background-color: rgba(233, 182, 94, 0.24);
}
.recommend-bg{
    background-color: var(--success-01);
}
.feedback-title{
    font-size: 14px;
    padding-left: 10px;
}
.feedback-desc{
    font-size: 12px;
    color:rgba(0, 0, 0, 0.6);
    padding-left: 10px;
}
.interviewer-name, .recommend-txt, .hold-txt{
    font-size: 14px;
}
.average-text{
    font-size: 14px;
}
.interview-remark{
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Adjust the number of lines for your needs */
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.6);
    text-align: left;
}
.interview-panels{
     width: 100%;
}
.containerPsychrometricHard, .containerPsychrometricLite, .containerComputerHard, .containerComputerLite, .containerEnglishHard, .containerEnglishLite, .containerCoreSkillLite ,.containerCoreSkillHard,.containerPedagigyHard,  .containerPedagigyLite{
    height: 100px;
    padding: 5px;
}
.main-table{
    display: flex;
}
.central-table{
    margin-top: 10px;
    width: 100vw;
    display: flex;  
}
.comment-section{
    width: 100vw;
    padding: 15px;
    margin-top: 5px;
}

.border-right {
    border-right: 1px solid #0000001F !important;
}

.score-container {
    background: #06C2702B;
    border: 1px solid #06C270;
    border-radius: 8px;
}

.w-90 {
    width: 90%
}

.col-2 {
    flex: 0 0 12.666667%;
    max-width: 12.6666666667%;
}

.larger-bottom{
    position: relative;
    width: 100%;

}
.m-width-none {
    max-width: none;
}
.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none;
}
.mt-100{
    margin-top: 100px;
}

</style>
